import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolder1"><Path d="M2.5 3.5V19.5H21.5V6.5H12L10 3.5H2.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconFolder1;
